import React from 'react';
import { SvgIcon } from '@mui/material';

export default function MenuIconMarket(props) {
  const { iconcolor } = props;
  return (
    <SvgIcon {...props} color="inherit" width="21" height="20" viewBox="0 0 21 20">
      <path d="M14.5 7H6.5C5.94772 7 5.5 7.44772 5.5 8V16C5.5 16.5523 5.94772 17 6.5 17H14.5C15.0523 17 15.5 16.5523 15.5 16V8C15.5 7.44772 15.0523 7 14.5 7Z" fill={iconcolor} />
      <path d="M5.27832 16.4515L6.21232 17.3855H14.7883L15.7223 16.4515V6.93945H5.27832V16.4515ZM5.67832 7.33945H15.3223V16.2855L14.6223 16.9855H6.37832L5.67832 16.2855V7.33945Z" fill={iconcolor} />
      <path d="M8.2338 3.54728H12.7658V6.53928H13.6998V3.54728L12.7658 2.61328V2.61528V2.61328H8.2338V2.61528V2.61328L7.2998 3.54728V6.53928H8.2338V3.54728Z" fill="#004C3B" />
      <path d="M14.4996 6.14045V3.22045L13.0956 1.81445H7.90159L6.49759 3.22045V6.14045H4.47559V16.7825L5.87959 18.1865H15.1176L16.5216 16.7825V6.14045H14.4996ZM16.1216 16.6185L14.9536 17.7865H6.04559L4.87759 16.6185V6.54045H6.89959V3.38445L8.06759 2.21445H12.9296L14.0976 3.38445V6.54045H16.1196V16.6185H16.1216Z" fill={iconcolor} />
    </SvgIcon>
  );
}
